"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Lock = function Lock() {
	return _react2.default.createElement(
		"g",
		{ id: "lock" },
		_react2.default.createElement("path", {
			d: "M324.324901,166.717464 L176.656507,166.717464 L176.656507,119.094788 C176.656507,78.4059738 209.725693,45.2605913 250.490704,45.2605913 C291.179518,45.2605913 324.324901,78.3297775 324.324901,119.094788 L324.324901,166.717464 Z M250.490704,380.981408 C224.279183,380.981408 202.868028,359.570253 202.868028,333.358732 C202.868028,307.147211 224.279183,285.736056 250.490704,285.736056 C276.702225,285.736056 298.11338,307.147211 298.11338,333.358732 C298.11338,359.570253 276.702225,380.981408 250.490704,380.981408 L250.490704,380.981408 Z M393.358732,166.717464 L369.509296,166.717464 L369.509296,119.094788 C369.509296,53.3373971 316.171899,0 250.490704,0 C184.733313,0 131.472112,53.3373971 131.472112,119.018592 L131.472112,166.641268 L107.622676,166.641268 C81.4111551,166.717464 60,188.128619 60,214.263944 L60,452.377324 C60,478.588845 81.4111551,500 107.622676,500 L393.358732,500 C419.570253,500 440.981408,478.588845 440.981408,452.377324 L440.981408,214.263944 C440.981408,188.128619 419.570253,166.717464 393.358732,166.717464 L393.358732,166.717464 Z",
			id: "Fill-1"
		})
	);
};

exports.default = Lock;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Lock.js
// module id = 2966
// module chunks = 4